module.exports = __webpack_public_path__ + "img/logo.bb7e20a1.png";